import Stack, { StackProps } from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

interface Property {
  label: string;
  value: string | number;
  color?: string;
}
interface Props extends StackProps {
  properties: Property[];
}

export default function PropertiesGrid({ properties, ...stackProps }: Props) {
  return (
    <Stack pt={2} pb={4} px={4} spacing={2} direction="column" {...stackProps}>
      {properties.map((property) => (
        <Grid key={`property-${property.label}`} container>
          <Grid xs={6} item>
            <Typography color="text.disabled">{property.label}</Typography>
          </Grid>
          <Grid xs={6} item>
            <Typography
              sx={{
                overflowWrap: "break-word",
                ...(property.color ? { color: property.color } : {}),
              }}>
              {property.value}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Stack>
  );
}
